export class Settings{
    constructor(public data: {
        ID?: Number,
        SMTPServer?: String,
        SMTPPort?: Number,
        SMTPUsername?: String,
        SMTPPassword?: String,
        UseSSL?: Boolean,
        EmailFrom?: String,
        BCCEmail?: String,
        SMSFTPServer?: String,
        SMSFTPUsername?: String,
        SMSFTPPassword?: String,
        VideoIDLink?: String,
        PaymentSlipPayeeName?: String,
        PaymentSlipPayeeAddress?: String,
        PaymentSlipPayeeSettlement?: String,
        PaymentSlipPaymentCode?: String,
        PaymentSlipAccountNumber?: String,
        EURExchangeRate?: Number,
        PlatimatikAccountNumber?: String,
        PlatimatikAddress?: String,
        PlatimatikCurrency?: String,
        PlatimatikJMBG?: String,
        PlatimatikName?: String,
        PlatimatikPostalCode?: String,
        PlatimatikSettlement?: String,
        PlatimatikTaxID?: String,
        OfferConfirmedNotificationEmail?: String,
        DigitalOfferPremiumRateLimit?: Number,
        AgentMustSign?: Boolean,
        LinkToSNOPZO?: String,
        LinkToSNOKomDom?: String
    }){}
}